import {
  campaignUpdateSchema,
  populatedCampaignSchema,
} from "@redotech/redo-marketing-common/campaigns/campaign-definition";

export const updateCampaign = {
  name: "updateCampaign" as const,
  input: campaignUpdateSchema,
  output: populatedCampaignSchema,
};
